"use client";

import { useEffect, useState } from "react";
import { Loaders } from "@/app/vars/Loaders";
import styles from "./PointsLoader.module.css";

type Props = {
  size?: number;
  gap?: number;
  dark?: boolean;
  color?: string;
  visible?: boolean;
  delay?: number;
  centered?: boolean;
};

export default function PointsLoader(props: Props) {
  const {
    size = Loaders.SIZE,
    gap = Loaders.GAP,
    dark,
    color,
    visible = true,
    delay = 0,
    centered = false,
  } = props;

  const [shouldRender, setShouldRender] = useState(delay === 0);

  useEffect(() => {
    if (delay <= 0) {
      setShouldRender(true);
      return;
    }

    const timer = setTimeout(() => {
      setShouldRender(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  if (!visible || !shouldRender) return null;

  const colorClass = dark === true ? styles.dark : dark === false ? styles.light : "";
  const containerClass = `${styles.container} ${centered ? styles.centered : ""}`;

  return (
    <div className={containerClass} style={{ height: size * 2, gap: `${gap}px` }}>
      {[1, 2, 3].map((_, index) => (
        <span
          key={index}
          className={`${styles.circle} ${colorClass}`}
          style={{ width: `${size}px`, height: `${size}px`, ...(color ? { color } : {}) }}
        />
      ))}
    </div>
  );
}
